import { type OptionsType, getCookie, setCookie } from 'cookies-next/server'
import CryptoJS from 'crypto-js'
import { ServerResponse } from 'http'
import { NextRequest, NextResponse } from 'next/server'
import { v4 } from 'uuid'
import { db, eq, schema } from '~/src/db'
import {
  DUPE_AUTH_USER_ID_KEY,
  DUPE_SESSION_COOKIE_KEY,
  MAX_AGE_OF_COOKIE,
  TEMP_USER_ID_KEY,
} from '~/src/lib/constants'

export const stringToHash = (str: string) => {
  return CryptoJS.MD5(str).toString(CryptoJS.enc.Hex)
}

export const isValidImageUrl = (url: string) => {
  try {
    if (url.startsWith('https://https')) {
      return false
    }

    new URL(url)
    return true
  } catch (e) {
    return false
  }
}

export async function decodeSourceFromHash(
  hash?: string
): Promise<string | null | undefined> {
  if (!hash) return
  const result = await db
    .select({
      source: schema.urls.source,
    })
    .from(schema.urls)
    .where(eq(schema.urls.hash, hash))

  return result[0]?.source
}

export const getTempUserIdCookieFromRequest = async (req: NextRequest) => {
  return await getCookie(TEMP_USER_ID_KEY, { req })
}

export const getUserIdCookieFromRequest = async (req: NextRequest) => {
  return await getCookie(DUPE_AUTH_USER_ID_KEY, { req })
}

export const generateAndSetTempUserIdServer = ({
  res,
}: {
  res: ServerResponse
}) => {
  const uuid = v4()

  const cookieOptions: OptionsType = {
    expires: new Date(Date.now() + 1000 * MAX_AGE_OF_COOKIE),
    maxAge: MAX_AGE_OF_COOKIE,
    path: '/',
    res,
  }

  if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
    cookieOptions.domain = '.dupe.com'
  }

  setCookie(TEMP_USER_ID_KEY, uuid, cookieOptions)

  return uuid
}

export const generateAndSetTempUserIdMiddleware = ({
  res,
}: {
  res: NextResponse
}) => {
  const uuid = v4()

  const cookieOptions: OptionsType = {
    expires: new Date(Date.now() + 1000 * MAX_AGE_OF_COOKIE),
    maxAge: MAX_AGE_OF_COOKIE,
    path: '/',
  }

  if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
    cookieOptions.domain = '.dupe.com'
  }

  res.cookies.set(TEMP_USER_ID_KEY, uuid, cookieOptions)

  return uuid
}

export const getDupeSessionCookie = (req: NextRequest) => {
  return getCookie(DUPE_SESSION_COOKIE_KEY, { req })
}
